import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import InputComp from '../../InputComp'

const MeslekModal = (props) => {
  const [InputName, setInputName] = useState('')
  const [meslekler, setMeslekler] = useState([])

  useEffect(() => {
    setMeslekler(props?.meslekler)
  }, [props?.meslekler, props.onHide])

  return (
    <Modal
      show={props.show}
      onHide={() => {
        setInputName('')
        props.onHide()
      }}
      style={{
        userSelect: 'none',
      }}
      size={20}
      centered
    >
      <Modal.Body className='meslekModal'>
        <InputComp
          label={'Meslek Arayın'}
          value={InputName}
          onChange={(e) => {
            let input = e.target.value.toLocaleLowerCase('tr').normalize('NFC')
            let data = props?.meslekler?.filter((item) =>
              item.name.toLocaleLowerCase('tr').normalize('NFC').includes(input)
            )

            setInputName(e.target.value)
            if (e.target.value?.length) {
              setMeslekler(data)
            } else {
              setMeslekler(props.meslekler)
            }
          }}
          placeholder={'Örn: Doktor'}
        />
        {meslekler?.map((item) => (
          <div
            className='meslekItem'
            key={item.id}
            onClick={() => {
              props.setMeslek(item)
              props.setMeslekInputClass('selectInput')
              setInputName('')
              props.onHide()
            }}
          >
            {item.name}
          </div>
        ))}
        <div
          style={{ position: 'absolute', top: '15px', right: '15px' }}
          onClick={() => {
            setInputName('')
            props.onHide()
          }}
        >
          X
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default MeslekModal
